<template>
  <dt-wrap>
    <div class="ds-version-history">
      <h3>Current Version</h3>
      <div class="grid-x">
        <div class="large-6">
          <cat-expando-box id="current_version" :label="versionData[0].version">
            <ul v-if="versionData[0].changes.length" class="pls">
              <template
                v-for="(change, index) in versionData[0].changes"
                :key="index"
              >
                <li>
                  {{ change }}
                </li>
              </template>
            </ul>
          </cat-expando-box>
        </div>
        <div class="large-6">Newest</div>
      </div>
      <template v-if="versionData.length > 1">
        <h3>Version History</h3>
        <template v-for="(version, index) in historicVersions" :key="index">
          <div class="grid-x">
            <div class="large-6">
              <cat-expando-box
                :id="'version_' + index"
                :label="version.version"
              >
                <ul v-if="version.changes.length" class="pls">
                  <template
                    v-for="(change, index2) in version.changes"
                    :key="index2"
                  >
                    <li>
                      {{ change }}
                    </li>
                  </template>
                </ul>
              </cat-expando-box>
            </div>
            <div class="large-6">
              {{ version.date }}
            </div>
          </div>
        </template>
      </template>
    </div>
  </dt-wrap>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "VersionHistory",
  props: {
    versions: {
      type: Array,
      default: function () {
        return [
          { version: "1.0", date: "latest", changes: ["Initial version"] }
        ];
      }
    },
    varName: {
      type: String
    }
  },
  data: function () {
    return {
      versionData: this.versions
    };
  },
  mounted: function () {
    this.versionData = window[this.varName] || this.versions;
  },
  computed: {
    historicVersions: function () {
      if (!this.versionData || this.versionData.length === 1) {
        return [];
      }
      return this.versionData.slice(1);
    }
  }
});
</script>
